// src/pages/Utilisateurs/PrepaPhysique/components/SkeletonPrepaCard.jsx

import React from "react";

export default function SkeletonPrepaCard() {
  return (
    <div className="overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="border-b border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
          <div className="space-y-2">
            <div className="h-3 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-5 w-44 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
          </div>
        </div>

        <div className="mt-4 h-2 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
      </div>

      <div className="grid grid-cols-1 gap-3 p-3 lg:grid-cols-2">
        {Array.from({ length: 2 }).map((_, index) => (
          <div
            key={index}
            className="overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950"
          >
            <div className="aspect-[16/10] animate-pulse bg-slate-200 dark:bg-slate-800" />

            <div className="space-y-3 p-4">
              <div className="h-5 w-4/5 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-4 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

              <div className="grid grid-cols-2 gap-2 pt-2">
                <div className="h-11 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
                <div className="h-11 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}